import { ResetPasswordContent } from './ResetPasswordContent';

export default function ResetPasswordPage() {
    return <ResetPasswordContent />;
}
